import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { getChapterIntakeUploadUrl } from "../lib/adminHost"

/** Sends visitors from the public site to the admin upload page. */
const ChapterIntakeUploadRedirect = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const chapter = searchParams.get("chapter") ?? undefined
    const email = searchParams.get("email") ?? undefined
    window.location.replace(getChapterIntakeUploadUrl({ chapter, email }))
  }, [searchParams])

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f4f6fb] font-dm-sans text-sm text-[#5a5a5a]">
      Taking you to the upload page…
    </div>
  )
}

export default ChapterIntakeUploadRedirect
